import React from "react";

function ChevronLeftIcon() {
  return (
    <svg data-testid="ChevronLeftIcon" viewBox="0 0 24 24">
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
    </svg>
  );
}

export default React.memo(ChevronLeftIcon);
